// extracted by mini-css-extract-plugin
module.exports = {"list-wrap":"ChatWrapper_list-wrap__ktQ4n","fetching":"ChatWrapper_fetching__7d7y9"};